// extracted by mini-css-extract-plugin
module.exports = {"KeyBinding":"KeyBinding__1d9EN","Key":"Key__1wpiV"};